export default __webpack_public_path__ + "static/media/11_Academy_Primary_Mark_RGB.e9834f0e.png";